// extracted by mini-css-extract-plugin
module.exports = {"tags":"NoteForm_tags__3xg-v"};